module.exports = __webpack_public_path__ + "static/media/Cyroth-EI.67e1be80.png";